import { atom } from 'recoil';

import * as K from 'common/constants';

/**
 * If true, the app is in full screen mode and the nav bar is not displayed.
 */
export const isFullScreenModeState = atom<boolean>({
  key: K.RECOIL_ATOM_KEY.IS_FULL_SCREEN_MODE,
  default: false,
});
